import stickySidebar from "sticky-sidebar";
window.stickySidebar = stickySidebar;
import ScrollMagic from 'scrollmagic';

const sidebar = new StickySidebar(".toc-block", {
    topSpacing: 100,
    bottomSpacing: 20,
    containerSelector: ".toc-parent",
    innerWrapperSelector: ".toc__inner",
});
const controller =new ScrollMagic.Controller({globalSceneOptions: {duration: 300,offset: 0}});
$('.toc-heading').each(function (i, el){
    new ScrollMagic.Scene({triggerElement: "#"+el.id})
					.setClassToggle("#toc-"+el.id, "toc-active") // add class toggle
					.addTo(controller);
});

